import { MutationKey, useMutation, useQuery } from 'react-query'
import request from '../../../request'
import { UseMutationResult } from 'react-query/types/react/types'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useVerifyFacebookLeadsAccount = (): UseMutationResult<
  { data: any; name: any },
  any,
  any
> => {
  const dealership = useDealership()
  return useMutation<any, { data: any; name: any }, any>(
    ({ params }: { params: { account_id: string } }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dsp/third_party/facebook_leads/verify`,
        method: 'GET',
        params,
      }),
  )
}
